import { createRoot } from "react-dom/client"
import { createInertiaApp } from "@inertiajs/react"
import type { ResolvedComponent } from "@inertiajs/react"
import "@/styles/application.css"

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<{ default: ResolvedComponent }>(
      "../pages/**/*.tsx",
      { eager: true }
    )
    const page = pages[`../pages/${name}.tsx`]

    if (!page) {
      throw new Error(`Unknown Inertia page: ${name}`)
    }

    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
